import type {
  IntegrationsSyncRunOriginEnum,
  MarketplaceIntegrationWithIdsFragment,
} from 'generated/resources/graphql'
import { SyncRunStatusChangeDocument } from 'generated/resources/graphql'

import { useSubscription } from 'modules/core/hooks/useSubscription'

import { type Parameters } from 'modules/integrations/lib/parameters'
import { useUpdateLastSyncRunQueryCache } from 'modules/integrations/hooks/SyncContext/useLastSyncRun'

interface UseSyncRunStatusChangedSubscriptionProps {
  marketplaceIntegration: MarketplaceIntegrationWithIdsFragment | null
  contextParameters: Parameters
  origin: IntegrationsSyncRunOriginEnum
  skip?: boolean
}

export const useSyncRunStatusChangedSubscription = ({
  marketplaceIntegration,
  contextParameters,
  origin,
  skip = false,
}: UseSyncRunStatusChangedSubscriptionProps) => {
  const updateLastSyncRunQueryCache = useUpdateLastSyncRunQueryCache()

  useSubscription(SyncRunStatusChangeDocument, {
    onData: ({ data: subscriptionData }) => {
      const syncRun = subscriptionData.data?.integrationsSyncRunStatusChange?.syncRun
      if (!syncRun || !marketplaceIntegration?.id) return

      // TODO: API&Marketplace will improve this to support multiple parameters and agnostic to context.
      // We'll try to decouple this part using something like an "CapabilityObject". This object will expose
      // an interface with filterKeys and a set of params to apply filters similar to those lines, but context-agnostic.
      const contextPayrollRunId = contextParameters.payroll_run_id
      const syncRunPayrollRunId = syncRun.parameters?.find((p) => p.key === 'payroll_run_id')?.value
      if (contextPayrollRunId && contextPayrollRunId !== syncRunPayrollRunId) {
        return
      }

      updateLastSyncRunQueryCache({
        marketplaceIntegration,
        contextParameters,
        syncRun,
        origin,
      })
    },
    skip,
  })
}
